import $axios from "../../api";
import FileSaver from "file-saver";

const state = () => ({
  isLoading: false,
  isLoadingOrct: false,
  isLoadingLog: false,
  isDetailLoading: false,
  isErrors: "",
  isSuccess: false,
  list: [],
  header: [],
  orct: [],
  lastSync: [],
  lastSyncDetail: [],
  syncLog: ({}),
  page: 1,
});

const mutations = {
  SET_LOADING(state, isLoading) {
    state.isLoading = isLoading;
  },
  SET_LOADING_ORCT(state, isLoadingOrct) {
    state.isLoadingOrct = isLoadingOrct;
  },
  SET_LOADING_LOG(state, isLoadingLog) {
    state.isLoadingLog = isLoadingLog;
  },
  SET_LOADING_DETAIL(state, isDetailLoading) {
    state.isDetailLoading = isDetailLoading;
  },
  ASSIGN_ERRORS(state, isErrors) {
    state.isErrors = isErrors;
  },
  SET_SUCCESS(state, payload) {
    state.isSuccess = payload;
  },
  SET_LIST(state, list) {
    state.list = list;
  },
  SET_HEADER(state, header) {
    state.header = header;
  },
  SET_SYNC_LOG(state, data) {
    state.syncLog = data;
  },
  SET_ORCT(state, orct) {
    state.orct = orct;
  },
  UPDATE_ORCT(state, payload) {
    const index = state.list.data.findIndex(item => item.key_value_union === payload.key_value_union);
    if (index !== -1) {
      state.list.data[index].orct = payload.orct;
    }
  },
  // UPDATE_LIST_ITEM(state, updatedItem) {
  //   console.log('updatedItem', updatedItem.key_value)
  //   console.log('list data', state.list.data.sm_id)
  //   const index = state.list.data.findIndex(item =>
  //     item.sm_id == '74870'
  //     // &&
  //     // item.table_name === updatedItem.table_name
  //   );
  //   if (index !== -1) {
  //     state.list.data[index].is_sync = 0;
  //   }
  // },
  SET_LAST_SYNC(state, payload) {
    state.lastSync = payload;
  },
  SET_LAST_SYNC_DETAIL(state, payload) {
    state.lastSyncDetail = payload;
  },
  SET_PAGE(state, payload) {
    state.page = payload;
  },
};

const actions = {

  async getHeader({ commit, dispatch }, payload) {
    commit("SET_LOADING", true);
    return new Promise((resolve, reject) => {
      $axios
        .get(`dashboardsync/monitoring/header`)
        .then((res) => {
          commit("SET_HEADER", res.data);
          commit("SET_LOADING", false);
          resolve(res.data);
        })
        .catch((error) => {
          commit("SET_LOADING", false);
          dispatch(
            "Main/globalSweetAlert",
            error.response || { message: "Unknown error" },
            { root: true }
          );
          reject(error);
        });
    });
  },
  async getList({ commit, dispatch, state, rootState }, query = "") {
    commit("SET_LOADING", true);
    return new Promise((resolve, reject) => {
      $axios
        .get(`dashboardsync/monitoring/list?page=${state.page}&view=${rootState.Main.view}${query}`)
        .then((res) => {
          commit("SET_LIST", res.data);
          commit("SET_LOADING", false);
          resolve(res.data);
        })
        .catch((error) => {
          commit("SET_LOADING", false);
          dispatch(
            "Main/globalSweetAlert",
            error.response || { message: "Unknown error" },
            { root: true }
          );
          reject(error);
        });
    });
  },
  async getOrct({ commit, dispatch }, payload) {
    commit("SET_LOADING_ORCT", true);
    return new Promise((resolve, reject) => {
      $axios
        .get(`dashboardsync/monitoring/get-orct`, {
          params: {
            docentry: payload
          }
        })
        .then((res) => {
          const orctData = res.data.data;
          commit("SET_ORCT", orctData);
          commit("UPDATE_ORCT", {
            key_value_union: payload,
            orct: orctData
          });

          commit("SET_LOADING_ORCT", false);
          resolve(res.data);
        })
        .catch((error) => {
          commit("SET_LOADING_ORCT", false);
          dispatch(
            "Main/globalSweetAlert",
            error.response || { message: "Unknown error" },
            { root: true }
          );
          reject(error);
        });
    });
  },
  resyncData({ commit, dispatch, state }, { payload, endpoint }) {
    commit("SET_SUCCESS", false);
    return new Promise((resolve, reject) => {
      const url = `dashboardsync/resync/${endpoint}`;
      $axios.post(url, { sync_master_id: payload })
        .then((response) => {
          commit("SET_SUCCESS", true);
          dispatch('Main/globalCustomSweetAlert', {
            message: response.data.message,
            position: 'top-end',
            timer: 2000,
          }, { root: true });
          resolve(response);
        })
        .catch((error) => {
          commit("SET_SUCCESS", false);
          dispatch('Main/globalSweetAlert', error.response, { root: true })
          reject(error);
        });
    });
  },
  getLog({ commit, dispatch }, payload) {
    commit("SET_LOADING_LOG", true);
    return new Promise((resolve, reject) => {
      $axios
        .get(`dashboardsync/monitoring/log`, {
          params: {
            sm_id: payload
          }
        })
        .then((res) => {
          commit("SET_SYNC_LOG", res.data);
          commit("SET_LOADING_LOG", false);
          resolve(res);
        })
        .catch((error) => {
          commit("SET_LOADING_LOG", false);
          dispatch(
            "Main/globalSweetAlert",
            error.response || { message: "Unknown error" },
            { root: true }
          );
          reject(error);
        });
    });
  },
  async getSyncProgress({ commit, dispatch }, payload) {
    commit("SET_LOADING", true);
    return new Promise((resolve, reject) => {
      $axios
        .get(`dashboardsync/monitoring/last-sync`)
        .then((res) => {
          commit("SET_LOADING", false);
          commit("SET_LAST_SYNC", res.data);
          resolve(res.data);
        })
        .catch((error) => {
          commit("SET_LOADING", false);
          dispatch(
            "Main/globalSweetAlert",
            error.response || { message: "Unknown error" },
            { root: true }
          );
          reject(error);
        });
    });
  },
  async getSyncProgressDetail({ commit, dispatch, state }, payload) {
    commit("SET_LOADING_DETAIL", true);
    const storeCode = payload.storeCode;
    return new Promise((resolve, reject) => {
      $axios
        .get(`dashboardsync/monitoring/last-sync/${storeCode}?page=${state.page}`)
        .then((res) => {
          commit("SET_LOADING_DETAIL", false);
          commit("SET_LAST_SYNC_DETAIL", res.data);
          resolve(res.data);
        })
        .catch((error) => {
          commit("SET_LOADING_DETAIL", false);
          dispatch(
            "Main/globalSweetAlert",
            error.response || { message: "Unknown error" },
            { root: true }
          );
          reject(error);
        });
    });
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
